import { IDashboardConciliacao, IDashboardContasConciliacaoPaginado, IDashboardResumoContasConciliacao } from "../interfaces/IDashboard";
import { DashboardFiltros } from "../pages/dashboard/types";
import api from './Api';

class DashboardService {
    private montarParamsPeriodo(filtros?: Partial<DashboardFiltros>): Record<string, string | number> {
        const params: Record<string, string | number> = {};

        if (!filtros) return params;

        switch (filtros.tipoPeriodo) {
            case 'personalizado':
                if (filtros.dataInicial && filtros.dataFinal) {
                    params.dataInicial = filtros.dataInicial;
                    params.dataFinal = filtros.dataFinal;
                }
                break;
            case 'dia':
                if (filtros.diaSelecionado) params.dia = filtros.diaSelecionado;
                break;
            case 'mes':
                if (filtros.mesSelecionado) params.mes = filtros.mesSelecionado;
                break;
            case 'ano':
            default:
                if (filtros.anoSelecionado) params.ano = filtros.anoSelecionado;
                break;
        }

        return params;
    }

    async obterConciliacao(empresaID: number, filtros?: Partial<DashboardFiltros>): Promise<IDashboardConciliacao> {
        const { data: result } = await api.get<IDashboardConciliacao>(
            `Dashboard/Conciliacao/${empresaID}`,
            { params: this.montarParamsPeriodo(filtros) }
        );

        return result;
    }

    async obterContasConciliacao(
        empresaID: number,
        filtros: Partial<DashboardFiltros> | undefined,
        conciliador: string | undefined,
        page: number,
        perPage: number
    ): Promise<IDashboardContasConciliacaoPaginado> {
        const { data: result } = await api.get<IDashboardContasConciliacaoPaginado>(
            `Dashboard/ConciliacaoContabilFinanceira/${empresaID}`,
            { params: { ...this.montarParamsPeriodo(filtros), ...(conciliador ? { conciliador } : {}), page, perPage } }
        );

        return result;
    }

    async obterResumoStatusContas(
        empresaID: number,
        filtros?: Partial<DashboardFiltros>,
        conciliador?: string
    ): Promise<IDashboardResumoContasConciliacao> {
        const { data: result } = await api.get<IDashboardResumoContasConciliacao>(
            `Dashboard/ConciliacaoContabilFinanceira/${empresaID}/resumo`,
            { params: { ...this.montarParamsPeriodo(filtros), ...(conciliador ? { conciliador } : {}) } }
        );

        return result;
    }

    async obterConciliadoresDisponiveis(empresaID: number, filtros?: Partial<DashboardFiltros>): Promise<string[]> {
        const { data: result } = await api.get<string[]>(
            `Dashboard/ConciliacaoContabilFinanceira/${empresaID}/conciliadores`,
            { params: this.montarParamsPeriodo(filtros) }
        );

        return result;
    }

    async obterAnosDisponiveis(empresaID: number): Promise<number[]> {
        const { data: esteiras } = await api.get<{ periodoInicio: string }[]>(`Esteira/empresa/${empresaID}`);

        const anos = Array.from(
            new Set(esteiras.map((esteira) => new Date(esteira.periodoInicio).getFullYear()))
        );

        return anos.sort((a, b) => b - a);
    }
}

export default new DashboardService();
